export default {
  cacheStartUpdating(state: any, payload: { cacheProperty:string, cachePropertyLevel2:string }) {
    const {cacheProperty, cachePropertyLevel2}= payload
    // for tags mostly
    if(cacheProperty && cachePropertyLevel2){
      return state.cache[cacheProperty][cachePropertyLevel2].isUploaded = false
    }
    // for rest
    if(cacheProperty){
      return state.cache[cacheProperty].isUploaded = false
    }
  },
  populateCampaignsCache(state: any, payload:Campaign[]) {
    state.cache.campaigns.data = payload
    state.cache.campaigns.isAllInCache = payload?.length < 199
    state.cache.campaigns.isUploaded = true
    state.cache.campaigns.uploadedForWorkspace = null
  },
  updateCampaignsCache(state: any, { workspaceId, data }:{ workspaceId:string, data: Campaign[] }) {
    state.cache.campaigns.data = data
    state.cache.campaigns.uploadedForWorkspace = workspaceId
  },
  populateOffersCache(state: any, payload:Offer[]) {
    state.cache.offers.data = payload
    state.cache.offers.isAllInCache = payload?.length < 199
    state.cache.offers.isUploaded = true
    state.cache.offers.uploadedForWorkspace = null
  },
  updateOffersCache(state: any, { workspaceId, data, countryId }:{ workspaceId:string,countryId:string,data: TrafficSource[] }) {
    state.cache.offers.data = data
    state.cache.offers.uploadedForWorkspace = workspaceId
    state.cache.offers.uploadedForCountryId = countryId
  },
  populateLandingsCache(state: any, payload:Landing[]) {
    state.cache.landings.data = payload
    state.cache.landings.isAllInCache = payload?.length < 199
    state.cache.landings.isUploaded = true
    state.cache.landings.uploadedForWorkspace = null
  },
  updateLandingsCache(state: any, { workspaceId, data, countryId }:{ workspaceId:string,countryId:string,data: TrafficSource[] }) {
    state.cache.landings.data = data
    state.cache.landings.uploadedForWorkspace = workspaceId
    state.cache.landings.uploadedForCountryId = countryId
  },
  updateTrafficSourcesCache(state: any, { workspaceId, data }:{ workspaceId:string,data: TrafficSource[] }) {
    state.cache.trafficSources.data = data
    state.cache.trafficSources.uploadedForWorkspace = workspaceId
  },
  populateTrafficSourcesCache(state: any, payload:TrafficSource[]) {
    state.cache.trafficSources.data = payload
    state.cache.trafficSources.isAllInCache = payload?.length < 199
    state.cache.trafficSources.isUploaded = true
    state.cache.trafficSources.uploadedForWorkspace = null
  },
  updateFlowsCache(state: any, { workspaceId, data, countryId }:{ workspaceId:string,countryId:string,data: TrafficSource[] }) {
    state.cache.flows.data = data
    state.cache.flows.uploadedForWorkspace = workspaceId
    state.cache.flows.uploadedForCountryId = countryId
  },
  populateFlowsCache(state: any, payload:TrafficSource[]) {
    state.cache.flows.data = payload
    state.cache.flows.isAllInCache = payload?.length < 199
    state.cache.flows.isUploaded = true
    state.cache.flows.uploadedForWorkspace = null
  },
  populateAffiliateNetworksCache(state: any, payload:TrafficSource[]) {
    state.cache.affiliateNetworks.data = payload
    state.cache.affiliateNetworks.isUploaded = true
  },
  populateTrackingDomainsCache(state: any, payload:TrackingDomain[]) {
    state.cache.trackingDomains.data = payload
    state.cache.trackingDomains.isUploaded = true
  },
  populateRedirectDomainsCache(state: any, payload:TrackingDomain[]) {
    state.cache.redirectDomains.data = payload
    state.cache.redirectDomains.isUploaded = true
  },
  populateTagsCache(state: any, payload:{
    type: 'campaigns' | 'offers' | 'landings',
    data: Tag[]
  }) {
    state.cache.tags[payload.type].data = payload.data
    state.cache.tags[payload.type].isUploaded = true
  },
  populateIntegrationsCache(state: any, payload:Integration[]) {
    state.cache.integrations.data = payload
    state.cache.integrations.isUploaded = true
  },
  updateIntegrationsCache(state: any, payload:Integration) {
    state.cache.integrations.data = state.cache.integrations.data.map((item:any)=>{
      if(item.id === payload.id){
        return payload
      }
      return item
    })
  },
};
